export default __webpack_public_path__ + "static/media/support700.2efdd926.png";